export const tooltipTextFormatter = (tooltipText: string) => {
  if (!tooltipText) {
    return tooltipText;
  }
  let newTooltipText = tooltipText;
  newTooltipText = newTooltipText.replace(/\n/g, " <br /> ");
  newTooltipText = newTooltipText.replace(/\r/g, " <br /> ");
  newTooltipText = newTooltipText.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
  return newTooltipText;
};
